// AUTO-GENERATED FILE — DO NOT EDIT BY HAND.
//
// 单一事实来源 / single source of truth: release/release-metadata.json（仓库根）。
// 重新生成： pnpm release:metadata
//
// 该基线被提交，使单测 / typecheck / 本地开发无需先跑生成器即可拿到正确版本；
// 发布 / CI 会再跑生成器把精确发布时间、git SHA、构建渠道烤进来。
export const GENERATED_RELEASE_METADATA = {
  versionName: '1.0.10',
  betaTag: '',
  releaseTimeIso: '2026-07-27T23:29:35+08:00',
  gitSha: '359eb3b3ee232e2a84ac991c46f7d1576d324826',
  buildChannel: 'production',
} as const;
